import MessageImg from "assets/images/message.svg";
import InsightsImg from "assets/images/insights.svg";
import InsightsActiveImg from "assets/images/insights-active.svg";
import BlessingsImg from "assets/images/blessings.svg";
import BlessingsActiveImg from "assets/images/blessings-active.svg";
import ProfileImg from "assets/images/profile.svg";
import SubscribeImg from "assets/images/dollar-coin-solid-icon.svg";
import WaveMenuImg from "assets/images/wave-menu.svg";
import { useNavigate, useLocation } from "react-router-dom";

import { useIsKeyboardOpen } from 'hooks/UseIsKeyboardOpen';

const Menu = [
  {
    name: "Daily Blessings",
    icon: BlessingsImg,
    iconActive: BlessingsActiveImg,
    route: "/blessings",
    enabled: true,
  },
  {
    name: "Get Insights",
    icon: InsightsImg,
    iconActive: InsightsActiveImg,
    route: "/insights",
    enabled: true,
  },
  {
    name: "Answers",
    icon: MessageImg,
    iconActive: MessageImg,
    route: "/answers",
    enabled: true,
  },
  {
    name: "Select Plan",
    icon: SubscribeImg,
    iconActive: SubscribeImg,
    route: "/subscription",
    enabled: true,
  },
  {
    name: "Profile",
    icon: ProfileImg,
    iconActive: ProfileImg,
    route: "/about-you",
    enabled: true,
  },
];

const AppMenu = () => {

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = (route: string) => {
    navigate(route);
  };

  const isKeyboardOpen = useIsKeyboardOpen();

  return (
    <>
    {/* <div style={{ position: 'fixed', top: 0, left: 0, background: 'black', color: 'lime', fontSize: 10, zIndex: 9999, padding: 4 }}>
      vv:{Math.round(window.visualViewport?.height ?? 0)} inner:{window.innerHeight} open:{String(isKeyboardOpen)}
    </div> */}

    {!isKeyboardOpen ? (
    <div className="w-full max-w-[350px] h-[70px] rounded-[60px] bg-white px-5 flex flex-row gap-1 mb-5">
      {Menu.map((item, index) => {
        const active = pathname.startsWith(item.route);
        return (
          <div
            key={index}
            className="flex items-center justify-center w-full relative cursor-pointer"
            onClick={() => handleClick(item.route)}
          >
            <img
              src={active ? item.iconActive : item.icon}
              alt={item.name}
              className="w-[24px] h-[24px]"
            />
            {active && (
              <img
                src={WaveMenuImg}
                alt="Wave"
                className="w-[63px] h-[13px] absolute bottom-0"
              />
            )}
          </div>
        );
      })}
    </div> ) : null}
    </>
  );
};

export default AppMenu;
